import { TFunction } from 'i18next';
import moment from 'moment';
import { TravellerBirthDate } from 'src/app/models/TravellerFormModel';
import * as Yup from 'yup';

export const getDateOfBirthValidation = (t: TFunction) => {
    const currentYear = moment(new Date()).year();

    return Yup.object()
        .shape({
            day: Yup.number()
                .typeError(t('birthday_day_empty_error'))
                .required(t('birthday_day_empty_error'))
                .min(1, t('birthday_day_range_error'))
                .max(31, t('birthday_day_range_error')),
            month: Yup.number()
                .typeError(t('birthday_month_empty_error'))
                .required(t('birthday_month_empty_error'))
                .min(1, t('birthday_month_range_error'))
                .max(12, t('birthday_month_range_error')),
            year: Yup.number()
                .typeError(t('birthday_year_empty_error'))
                .required(t('birthday_year_empty_error'))
                .min(1, t('birthday_year_empty_error')) // Ensures at least 4 digits
                .max(currentYear, t('birthday_year_error', { currentYear })),
        })
        .test('isValidDay', t('birthday_day_range_error'), (value) => {
            const castedBirthDay = value as TravellerBirthDate;
            const day = Number(castedBirthDay.day);
            return day >= 1 && day <= 31;
        })
        .test('isValidMonth', t('birthday_month_range_error'), (value) => {
            const castedBirthDay = value as TravellerBirthDate;

            const month = Number(castedBirthDay.month);
            return month >= 1 && month <= 12;
        })
        .test('isValidYear', t('birthday_year_empty_error'), (value) => {
            const castedBirthDay = value as TravellerBirthDate;
            const year = Number(castedBirthDay.year);

            if (year.toString().length < 4) {
                return false;
            }

            return year >= 1000;
        })
        .test('isValidYear', t('birthday_year_error', { currentYear }), (value) => {
            const castedBirthDay = value as TravellerBirthDate;
            return Number(castedBirthDay.year) <= moment().year();
        });
};
